if (!customElements.get('b2b-catalogue')) {
  customElements.define('b2b-catalogue', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      const form = this.querySelector('[data-b2b-filters]');
      const home = this.querySelector('[data-b2b-filter-home]');
      const dialog = this.querySelector('dialog');
      const drawer = this.querySelector('[data-b2b-drawer-content]');
      const open = this.querySelector('[data-b2b-open]');
      const mobile = window.matchMedia('(max-width: 999px)');
      const placeForm = () => {
        if (dialog.open) dialog.close();
        (mobile.matches ? drawer : home).append(form);
      };
      for (const name of ['view', 'preview_theme_id']) {
        const value = new URLSearchParams(window.location.search).get(name);
        if (value) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = name;
          input.value = value;
          form.append(input);
        }
      }
      open.addEventListener('click', () => {
        dialog.showModal();
        open.setAttribute('aria-expanded', 'true');
      }, { signal });
      this.querySelector('[data-b2b-close]').addEventListener('click', () => dialog.close(), { signal });
      dialog.addEventListener('close', () => {
        open.setAttribute('aria-expanded', 'false');
        if (mobile.matches) open.focus();
      }, { signal });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const focusable = Array.from(dialog.querySelectorAll('button, input:not([type="hidden"])')).filter(element => !element.disabled);
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }, { signal });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      }, { signal });
      this.querySelector('[data-b2b-sort]').addEventListener('change', () => form.requestSubmit(), { signal });
      mobile.addEventListener('change', placeForm, { signal });
      this.classList.add('is-enhanced');
      placeForm();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  });
}
